<template>
  <div>
    <div class="bg-white border border-solid border-grey-light rounded-lg sm:p-7 p-5">
      <div v-if="profileCompletionLoading" class="card-loader"></div>
      <template v-else>
        <div class="flex md:flex-row flex-col gap-y-10 justify-between relative">
          <div v-for="(step, index) in profileCompletionSteps" :key="index" class="text-center flex md:flex-col items-center gap-2">
            <div class="progress-line absolute bg-grey-light border border-solid border-grey-light"></div>
            <span :class="`material-symbols-rounded fill text-3xl flex-shrink-0 z-10 ${(step.complete || inProgressStep(step)) ? 'text-primary' : 'text-grey-light'}`">{{ step.complete ? 'check_circle' : 'circle' }}</span>
            <p :class="`px-1 ${step.complete ? '' : 'underline cursor-pointer'} ${(step.complete || inProgressStep(step)) ? 'text-black' : 'text-grey cursor-text'}`" @click="inProgressStep(step) ? completeStep(step.check) : ''">{{ $t(step.check) }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  props: ['profileCompletionSteps', 'profileCompletionLoading'],
  data () {
    return {
    }
  },
  methods: {
    completeStep (step) {
      switch (step) {
      case 'profile_complete':
        this.toCompleteprofile()
        break
      case 'account_type':
        this.$router.push(`/${this.$route.params.lang}/merchant/account-settings/tax-profile`).catch(() => {})
        break
      case 'payout_method':
        this.$router.push(`/${this.$route.params.lang}/merchant/payout-methods`).catch(() => {})
        break
      case 'first_order':
        this.$router.push(`/${this.$route.params.lang}/merchant/orders/delivery-orders`).catch(() => {})
        break
      default:
        break
      }
    },
    inProgressStep (step) {
      if (step.check === this.profileCompletionSteps.filter(item => !item.complete)[0].check) {
        return true
      }
    },
    toCompleteprofile () {
      this.$router.push({ name: 'merchant-complete-profile' })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss">
[dir=ltr] .progress-line {
  top: 12px;
  left: 5em;
  width: calc(100% - 10em);
}
[dir=rtl] .progress-line {
  top: 12px;
  right: 4em;
  width: calc(100% - 8em);
}
@media (max-width: 1199px) {
  [dir=ltr] .progress-line {
    top: 12px;
    left: 4em;
    width: calc(100% - 8em);
  }
  [dir=rtl] .progress-line {
    top: 12px;
    right: 3.5em;
    width: calc(100% - 7em);
  }
}
@media (max-width: 767px) {
  [dir=ltr] .progress-line {
    top: 13px;
    left: 12px;
    height: calc(100% - 26px);
    width: 1px;
  }
  [dir=rtl] .progress-line {
    top: 13px;
    right: 12px;
    height: calc(100% - 26px);
    width: 1px;
  }
}
</style>